import { Translate, useFormController } from '@dreryk/react-common';
import {
   componentsTranslationKeys,
   DatePicker,
   dayValidator,
   StyledFlex,
   StyledMaxWidth,
} from '@dreryk/react-components';

import { DiseaseAutosuggest } from '~libs.desktop.shared.visit-medical-documents.diagnoses';

import { statisticsTranslationKeys } from '../../translations';

import {
   GenerateHealthcareProviderPatientsWithDiagnosisFormBean,
   GenerateHealthcareProviderPatientsWithDiagnosisFormController,
} from './GenerateHealthcareProviderPatientsWithDiagnosisForm.types';

type GenerateHealthcareProviderPatientsWithDiagnosisFormRenderProps = Pick<
   GenerateHealthcareProviderPatientsWithDiagnosisFormController,
   'handleSubmit' | 'formState'
>;

type GenerateHealthcareProviderPatientsWithDiagnosisFormProps = {
   readonly children: (renderProps: GenerateHealthcareProviderPatientsWithDiagnosisFormRenderProps) => JSX.Element;
};

export const GenerateHealthcareProviderPatientsWithDiagnosisForm = (
   props: GenerateHealthcareProviderPatientsWithDiagnosisFormProps
): JSX.Element => {
   const {
      register,
      handleSubmit,
      formState,
      watch,
   } = useFormController<GenerateHealthcareProviderPatientsWithDiagnosisFormBean>({
      diagnosis: null,
   });

   const { from: dateFrom, to: dateTo } = watch(['from', 'to']);

   return (
      <StyledFlex as={'form'} direction={'column'} gap={'24px'}>
         <Translate>{statisticsTranslationKeys.modal.type.healthcareProviderPatientsWithDiagnosis}</Translate>

         <DiseaseAutosuggest
            register={register}
            name={'diagnosis'}
            dictionaryValidOn={new Date()}
            validationRules={{ required: true }}
            testId={'diagnosis'}
         />

         <StyledFlex direction={'row'} gap={'24px'}>
            <StyledMaxWidth maxWidth={142}>
               <DatePicker
                  testId={'from'}
                  placeholder={componentsTranslationKeys.datePickerPlaceholder}
                  controller={register('from', { required: true })}
                  label={statisticsTranslationKeys.modal.from}
                  dayValidators={[dayValidator.dayAfterToday(), dayValidator.dayAfterReferenceDay(dateTo)]}
               />
            </StyledMaxWidth>
            <StyledMaxWidth maxWidth={142}>
               <DatePicker
                  testId={'to'}
                  placeholder={componentsTranslationKeys.datePickerPlaceholder}
                  controller={register('to')}
                  label={statisticsTranslationKeys.modal.to}
                  dayValidators={[dayValidator.dayAfterToday(), dayValidator.dayBeforeReferenceDay(dateFrom)]}
               />
            </StyledMaxWidth>
         </StyledFlex>

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </StyledFlex>
   );
};
